{
  "title": "Configuración de IA",
  "cancel": "Cancelar",
  "save": "Guardar",
  "newPrompt": "Nuevo Comando",
  "editPrompt": "Editar Comando",
  "configureAI": "Configurar IA",
  "update": "Actualizar",
  "create": "Crear",
  "confirmDelete": "¿Está seguro de que desea eliminar este comando?",
  "delete": "Eliminar",
  "prompt": "Comando",
  "promptName": "Nombre del Comando",
  "promptModel": "Modelo",
  "actions": "Acciones",
  "modelAgent": "Modelo de Agente",
  "promptSystemEnglish": "Comando del Sistema (Inglés)",
  "promptSystemSpanish": "Comando del Sistema (Español)",
  "promptScreenEnglish": "Comando de Pantalla (Inglés)",
  "promptScreenSpanish": "Comando de Pantalla (Español)",
  "promptImageEnglish": "Comando de Imagen (Inglés)",
  "promptImageSpanish": "Comando de Imagen (Español)",
  "english": "Inglés",
  "spanish": "Español",
  "description": "Descripción",
  "content": "Contenido",
  "saving": "Guardando...",
  "deletePrompt": "Eliminar Comando",
  "mainConfig": "Configuración Principal",
  "promptSystem": "Comando del Sistema",
  "promptScreen": "Comando de Pantalla",
  "promptImage": "Comando de Imagen",
  "prompts": "Comandos"
}
